import loadable from '@loadable/component';

export const IntegrateAtsLinksLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "IntegrateAtsLinks" */
      './IntegrateAtsLinks.dynamic'
    ),
);
